import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      color="text-primary"
      viewBox="0 0 16.62 36.25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className=""
        d="M8.31 10.72A5.36 5.36 0 1 1 8.31 0a5.36 5.36 0 0 1 0 10.72Zm0-8.72C6.46 2 4.95 3.51 4.95 5.36s1.51 3.36 3.36 3.36 3.36-1.51 3.36-3.36S10.16 2 8.31 2ZM14.7 25.76H1.92A1.92 1.92 0 0 1 0 23.84v-7.62c0-2.48 2.02-4.5 4.5-4.5h7.61c2.48 0 4.5 2.02 4.5 4.5v7.62c0 1.06-.86 1.92-1.92 1.92Zm-12.7-2h12.62v-7.54a2.5 2.5 0 0 0-2.5-2.5H4.51a2.5 2.5 0 0 0-2.5 2.5v7.54ZM9.84 36.25H7.07c-1.02 0-1.89-.6-2.12-1.45l-1.68-6.27a.994.994 0 0 1 .71-1.22.994.994 0 0 1 1.22.71l1.67 6.25h2.96c.09 0 .16-.02.2-.04l1.36-6.16c.12-.54.65-.88 1.19-.76.54.12.88.65.76 1.19l-1.38 6.24c-.2.9-1.07 1.53-2.13 1.53Zm.18-1.96Z"
      />
    </svg>
  )
}
export default Icon
